// SERVER-SIDE HANDLING FOR IMAGE UPLOADS
// Add this code to your theme.js or a separate JavaScript file

/**
 * Process image uploads by creating a proper server-side image attachment
 * This implementation uses Shopify's File API to store the images
 */

const ShopifyImageHandler = {
  /**
   * Initialize the image handler with the necessary configuration
   */
  init: function() {
    // Listen for form submissions with image data
    document.addEventListener('submit', function(event) {
      const form = event.target;
      
      // Check if this is a product form with image data
      const imageDataField = form.querySelector('[name="properties[_image_data]"]');
      if (!imageDataField || !imageDataField.value) return;
      
      // Prevent the default form submission
      event.preventDefault();
      
      // Process the images
      ShopifyImageHandler.processImages(imageDataField.value, form)
        .then(() => {
          // Submit the form after processing
          form.submit();
        })
        .catch(error => {
          console.error('Error processing images:', error);
          // Show error to user
          const errorMsg = document.createElement('div');
          errorMsg.className = 'image-upload-error';
          errorMsg.textContent = 'Failed to upload images. Please try again.';
          errorMsg.style.color = 'red';
          errorMsg.style.marginTop = '10px';
          form.appendChild(errorMsg);
        });
    });
  },
  
  /**
   * Process the images by sending them to the Shopify File API
   * @param {string} imageDataJson - JSON string containing image data
   * @param {HTMLFormElement} form - The form element
   * @returns {Promise} - Resolves when all images are processed
   */
  processImages: async function(imageDataJson, form) {
    try {
      const imageData = JSON.parse(imageDataJson);
      if (!imageData || !imageData.length) return;
      
      // Sort images by their order property to maintain the correct sequence
      const sortedImages = [...imageData].sort((a, b) => a.order - b.order);
      
      // Create an array to store image URLs
      const imageUrls = [];
      
      // Process each image in the correct order
      for (const image of sortedImages) {
        // Create a proper file from the data URL
        const file = this.dataURLtoFile(image.data, image.name);
        
        // Upload to Shopify's file storage
        const uploadedUrl = await this.uploadFileToShopify(file);
        if (uploadedUrl) {
          imageUrls.push(uploadedUrl);
        }
      }
      
      // Update the form with the image URLs in the correct order
      if (imageUrls.length > 0) {
        // Create or update hidden fields for each image URL
        imageUrls.forEach((url, index) => {
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = `properties[Image ${index + 1}]`;
          field.value = url;
          form.appendChild(field);
        });
        
        // Remove the original data field to avoid sending large data
        const imageDataField = form.querySelector('[name="properties[_image_data]"]');
        if (imageDataField) {
          imageDataField.remove();
        }
      }
      
    } catch (error) {
      console.error('Error processing images:', error);
      throw error;
    }
  },
  
  /**
   * Convert a data URL to a File object
   * @param {string} dataUrl - The data URL
   * @param {string} filename - The filename
   * @returns {File} - The File object
   */
  dataURLtoFile: function(dataUrl, filename) {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, { type: mime });
  },
  
  /**
   * Upload a file to Shopify's file storage
   * @param {File} file - The file to upload
   * @returns {Promise<string>} - Resolves with the URL of the uploaded file
   */
  uploadFileToShopify: async function(file) {
    try {
      // NOTE: This is a simplified example. In a real implementation,
      // you would need to create an endpoint in your Shopify app or use
      // a third-party service to handle the file upload.
      
      // This is a placeholder for the actual implementation
      const formData = new FormData();
      formData.append('file', file);      
      // Example API endpoint
      const response = await fetch('/apps/your-app/upload', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        throw new Error('Failed to upload file');
      }
      
      const data = await response.json();
      return data.url;
    } catch (error) {
      console.error('Error uploading file:', error);
      return null;
    }
  }
};

// Initialize the image handler
document.addEventListener('DOMContentLoaded', function() {
  ShopifyImageHandler.init();
});